import { isAdded, isInLupa, isRemoved } from "@/css/label";
import { __ } from "i18n-for-browser";
import { filter, find, flatten, map, pathEq, propEq } from "ramda";
import { getLocalizedProperty } from "../utils";
import { createDynamicTextFields } from "../dynamic";
import { PaikallisenTietovarastonAvain } from "@/enums";
import localForage from "localforage";

export async function muutEhdot(
  { maaraykset, sectionId },
  { isPreviewModeOn, isReadOnly },
  locale,
  changeObjects,
  { onAddButtonClick }
) {
  const _isReadOnly = isPreviewModeOn || isReadOnly;
  const poMuutEhdot = await localForage.getItem(
    PaikallisenTietovarastonAvain.PO_MUUT_EHDOT
  );
  const lisatiedot = await localForage.getItem(
    PaikallisenTietovarastonAvain.LISATIEDOT
  );

  const lisatiedotObj = find(
    pathEq(["koodisto", "koodistoUri"], "lisatietoja"),
    lisatiedot || []
  );

  const lisatietomaarays = find(propEq("koodisto", "lisatietoja"), maaraykset);

  return flatten([
    map(ehto => {
      const ehtoonLiittyvatMaaraykset = filter(
        m =>
          propEq("koodiarvo", ehto.koodiarvo, m) &&
          propEq(
            "koodisto",
            "pomuutkoulutuksenjarjestamiseenliittyvatehdot",
            m
          ),
        maaraykset
      );

      return {
        anchor: ehto.koodiarvo,
        components: [
          {
            anchor: "valintaelementti",
            name: "CheckboxWithLabel",
            properties: {
              isPreviewModeOn,
              isReadOnly: _isReadOnly,
              title: getLocalizedProperty(ehto.metadata, locale, "nimi"),
              labelStyles: {
                addition: isAdded,
                removal: isRemoved,
                custom: Object.assign(
                  {},
                  ehtoonLiittyvatMaaraykset.length ? isInLupa : {}
                )
              },
              isChecked: !!ehtoonLiittyvatMaaraykset.length,
              isIndeterminate: false
            }
          }
        ],
        categories: createDynamicTextFields(
          sectionId,
          ehtoonLiittyvatMaaraykset,
          changeObjects,
          ehto.koodiarvo,
          onAddButtonClick,
          isPreviewModeOn,
          isReadOnly,
          ehto.koodiarvo === "99" ? 10 : 1,
          poMuutEhdot,
          locale
        )
      };
    }, poMuutEhdot),
    lisatiedotObj
      ? [
          {
            anchor: "lisatiedotTitle",
            layout: { margins: { top: "large" } },
            styleClasses: ["mt-10", "pt-10", "border-t"],
            components: [
              {
                anchor: lisatiedotObj.koodiarvo,
                name: "StatusTextRow",
                properties: {
                  title: __("common.lisatiedotInfo")
                }
              }
            ]
          },
          {
            anchor: "lisatiedot",
            components: [
              {
                anchor: lisatiedotObj.koodiarvo,
                name: "TextBox",
                properties: {
                  forChangeObject: {
                    koodiarvo: lisatiedotObj.koodiarvo,
                    koodisto: lisatiedotObj.koodisto,
                    versio: lisatiedotObj.versio,
                    voimassaAlkuPvm: lisatiedotObj.voimassaAlkuPvm
                  },
                  isPreviewModeOn,
                  isReadOnly: _isReadOnly,
                  title: __("common.lisatiedot"),
                  value: lisatietomaarays ? lisatietomaarays.meta.arvo : ""
                }
              }
            ]
          }
        ].filter(Boolean)
      : null
  ]).filter(Boolean);
}
